module.exports = __webpack_public_path__ + "img/1.6fc59b02.svg";